// @flow

export const phone = (errorMessage: string = 'Error') => (value: string) => (
  value && !/(^0[0-9]{8,9}$|^0[0-9][\s.-][0-9]{7,8}$|^0[0-9]{2}[\s.-][0-9]{6,7}$|^0[0-9]{3}[\s.-][0-9]{5,6}$)|(^\s*$)/i.test(value)
    ? (errorMessage || 'Invalid phonenumber')
    : undefined
);

export default null;
